import {
  IApiSuccessWrapper,
  IExportStatus,
  IHCAMCAClassLocationTableObject
} from '$/types'
import { apiSlice } from 'app/services/api'
import { IGetHMCATableQueryParams } from './consequencearea'

const SYSTEM_SCOPE_ID_PARAM_NAME = 'systemScopeId'

export const hmcaClassLocationDataTableApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getHMCAClassLocationTable: build.query<
      IHCAMCAClassLocationTableObject,
      IGetHMCATableQueryParams
    >({
      query: ({
        systemScopeId,
        classification,
        routeIds,
        fromDate,
        toDate
      }) => ({
        method: 'POST',
        url: '/classlocation',
        params: {
          [SYSTEM_SCOPE_ID_PARAM_NAME]: systemScopeId
        },
        body: {
          classification,
          routeIds,
          fromDate,
          toDate
        }
      }),
      transformResponse: (
        res: IApiSuccessWrapper<IHCAMCAClassLocationTableObject>
      ) => {
        return res.result
      }
    }),
    addHMCAClassLocationTableExportJob: build.mutation<
      IExportStatus,
      IGetHMCATableQueryParams
    >({
      query: ({
        systemScopeId,
        classification,
        routeIds,
        fromDate,
        toDate
      }) => ({
        method: 'POST',
        url: '/classlocation/export',
        params: {
          [SYSTEM_SCOPE_ID_PARAM_NAME]: systemScopeId
        },
        body: {
          classification,
          routeIds,
          fromDate,
          toDate
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IExportStatus
      }
    })
  })
})

export const {
  useGetHMCAClassLocationTableQuery,
  useAddHMCAClassLocationTableExportJobMutation
} = hmcaClassLocationDataTableApi
